import styled from '@emotion/styled'
import React from 'react'
import { colors } from '../../__styling/settings/colors'

export interface TheNightlyStackedLogoProps {
    className?: string
    fillColor?: string
    logoWidth?: '100%' | number | undefined
    logoHeight?: number | undefined
}

const StyledSVG = styled('svg')<TheNightlyStackedLogoProps>(
    {
        color: colors.black,
    },
    (props) => ({
        // IE11 and some android browsers requires a height and width to render correctly
        maxHeight: props.logoHeight,
        maxWidth: props.logoWidth,
        width: '100%',
    }),
)

export const TheNightlyStackedLogo: React.FC<TheNightlyStackedLogoProps> = ({
    className,
    fillColor = colors.white,
    logoWidth,
    logoHeight,
}) => (
    <StyledSVG
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 275 80"
        logoWidth={logoWidth}
        logoHeight={logoHeight}
    >
        <g id="tn-logo-stacked">
            <path
                d="M86 7.32623V0H115.109V7.32623H105.035V33.4913H96.0736V7.32623H86ZM117.379 33.4913V0H126.472V13.0826H138.508V0H147.6V33.4913H138.508V20.4088H126.472V33.4913H117.379ZM150.766 0V33.4913H174.838V26.1651H159.859V20.4088H173.661V13.0826H159.859V7.32623H174.903V0H150.766ZM150.583 55.5846C150.888 56.0207 151.112 56.5276 151.253 57.1054H160.444C160.269 55.4265 159.779 53.8838 158.972 52.4775C158.165 51.0711 157.102 49.8555 155.783 48.8307C154.475 47.795 152.965 46.9991 151.253 46.4431C149.553 45.8762 147.71 45.5928 145.726 45.5928C143.469 45.5928 141.354 45.9743 139.381 46.7375C137.408 47.4897 135.669 48.6072 134.164 50.0899C132.66 51.5617 131.482 53.366 130.632 55.5028C129.792 57.6396 129.373 60.0926 129.373 62.8617C129.373 66.394 130.06 69.4412 131.433 72.0032C132.818 74.5652 134.742 76.5385 137.206 77.923C139.67 79.3076 142.532 79.9999 145.791 79.9999C148.713 79.9999 151.302 79.4275 153.559 78.2828C155.827 77.1272 157.604 75.47 158.89 73.3114C160.188 71.1419 160.836 68.5308 160.836 65.4782V60.8339H145.988V67.3098H152.069C152.045 68.2444 151.817 69.062 151.384 69.7628C150.926 70.5041 150.234 71.0765 149.307 71.4799C148.392 71.8833 147.241 72.0849 145.857 72.0849C144.287 72.0849 142.973 71.7143 141.916 70.9729C140.858 70.2316 140.062 69.1632 139.528 67.7677C138.994 66.3722 138.727 64.6933 138.727 62.7309C138.727 60.7903 139.005 59.1332 139.561 57.7595C140.128 56.3859 140.945 55.3338 142.014 54.6034C143.093 53.8729 144.396 53.5077 145.922 53.5077C146.631 53.5077 147.28 53.5895 147.868 53.753C148.468 53.9056 148.991 54.14 149.438 54.4562C149.896 54.7615 150.278 55.1376 150.583 55.5846ZM114.978 46.0507V79.542H107.39L95.2886 61.946H95.0924V79.542H86V46.0507H93.7187L105.624 63.5813H105.886V46.0507H114.978ZM127.22 46.0507V79.542H118.128V46.0507H127.22ZM163.925 79.542V46.0507H173.017V59.1332H185.053V46.0507H194.145V79.542H185.053V66.4594H173.017V79.542H163.925ZM196.396 46.0507V53.3769H206.469V79.542H215.431V53.3769H225.504V46.0507H196.396ZM227.775 79.542V46.0507H236.867V72.2158H250.408V79.542H227.775ZM255.626 46.0507H245.487L257.785 69.0105V79.542H266.812V69.0105L279.109 46.0507H268.97L262.429 59.6565H262.168L255.626 46.0507Z"
                fill="white"
            />
            <g id="logo-icon">
                <path
                    d="M74.6136 80V0H52.8997V41.875H52.2748L23.8437 0H5.4104L5.4104 54H27.1243V37.9688H27.5929L56.4926 80H74.6136Z"
                    fill={fillColor}
                />
                <path
                    d="M16.1728 80C10.2231 80 5.3999 75.1758 5.3999 69.2249C5.3999 63.2741 10.2231 58.45 16.1728 58.45C22.1224 58.45 26.9456 63.2741 26.9456 69.225C26.9456 75.1758 22.1224 80 16.1728 80Z"
                    fill={fillColor}
                />
            </g>
        </g>
    </StyledSVG>
)
TheNightlyStackedLogo.displayName = 'TheNightlyStackedLogo'
